const { useContext } = require('react')
const { ApprovalsDetailsContext } = require('../providers')

const useApprovalDetails = () => useContext(ApprovalsDetailsContext)

export { useApprovalDetails }
